{
  "title": "Recyclables pickup",
  "lead": "Ask the Municipal Environment and Natural Resources Office to collect your sorted recyclables at home.",
  "unavailableTitle": "Pickups aren't available yet",
  "unavailableBody": "The office in charge of waste will post the materials it collects and the collection days here.",
  "howTitle": "How it works",
  "how1": "Sort and clean your recyclables, then tell us what you have.",
  "how2": "Choose a collection day for your barangay, or the next available one.",
  "how3": "Hand them over on that day and keep the receipt in the app.",
  "materialsTitle": "What we collect",
  "perUnit": "by {unit}",
  "daysTitle": "Upcoming collection days",
  "noDays": "No collection days are scheduled yet. You can still ask for the next available one.",
  "wholeTown": "Whole town",
  "openSlots": "Open",
  "full": "Full",
  "slotsLeft": "{count} slots left",
  "signInToRequest": "Sign in to ask for a pickup and follow it here.",
  "formTitle": "Ask for a pickup",
  "checkForm": "Please check the highlighted fields.",
  "whereTitle": "Where to collect",
  "address": "House number and street, or sitio",
  "addressHint": "So the collector can find you.",
  "landmark": "Landmark",
  "landmarkPlaceholder": "e.g. beside the chapel",
  "mapLabel": "Map of the pickup location",
  "whenTitle": "Collection day",
  "nextAvailable": "Next available day",
  "noDayForBarangay": "There's no collection day for your barangay yet. Choose the next available day and the office will schedule you.",
  "whatTitle": "What you're handing over",
  "whatHint": "Enter an estimate for the materials you have. Leave the others blank.",
  "photoLabel": "Photo of the recyclables",
  "youTitle": "Your contact details",
  "mobileHint": "The collector may text or call before coming.",
  "notes": "Notes",
  "notesHint": "Anything the collector should know, e.g. where to wait.",
  "send": "Ask for a pickup",
  "sending": "Sending…",
  "errQty": "Enter quantities above zero, like 2 or 2.5.",
  "errNoMaterials": "Enter at least one material.",
  "errBarangay": "Choose your barangay.",
  "errDay": "Choose a collection day.",
  "errAddress": "Enter the address.",
  "errName": "Enter your name.",
  "errConsent": "Please agree to the privacy notice to send this.",
  "createdTitle": "Pickup requested",
  "createdScheduled": "You're on the collection day {date}. Please have your recyclables ready.",
  "createdWaiting": "The office will put you on the next collection day and let you know.",
  "viewPickup": "Follow this pickup",
  "another": "Ask for another pickup",
  "mineTitle": "My pickups",
  "onDay": "Collection day: {date}",
  "noDayYet": "Waiting for a collection day",
  "pickupTitle": "Recyclables pickup",
  "timelineTitle": "What happened",
  "detailsTitle": "Details",
  "officeLabel": "Office",
  "expected": "What you said you'd hand over",
  "photoAlt": "Photo of the recyclables",
  "receiptTitle": "Collection receipt",
  "printReceipt": "Print receipt",
  "receiptNo": "Receipt number",
  "reference": "Reference",
  "collectedOn": "Collected on",
  "collector": "Collector",
  "collectedItems": "Collected",
  "receiptNote": "Keep this receipt for your records.",
  "cancelPickup": "Cancel this pickup",
  "cancelTitle": "Cancel this pickup?",
  "cancelBody": "The collector won't come for these recyclables. You can ask for a new pickup anytime.",
  "cancelYes": "Yes, cancel",
  "cancelKeep": "Keep it",
  "cancelledToast": "Pickup cancelled.",
  "status_requested": "Waiting for a day",
  "status_scheduled": "Scheduled",
  "status_collected": "Collected",
  "status_missed": "Missed",
  "status_cancelled": "Cancelled",
  "adminTitle": "Recyclables pickup",
  "adminLead": "Put requests on collection days, record what was collected with a receipt number, and print the collector's sheet.",
  "tabPickups": "Pickups",
  "tabRounds": "Collection days",
  "tabMaterials": "Materials",
  "tabExport": "Export",
  "filterAll": "All",
  "dayFilter": "Collection day",
  "anyDay": "Any day",
  "searchPlaceholder": "Reference, name, mobile or address",
  "noPickupsTitle": "No pickups here",
  "noPickupsBody": "Requests from residents will appear here.",
  "directions": "Directions",
  "requestedOn": "requested {date}",
  "receiptShort": "Receipt {no}",
  "putOnDay": "Put on a day",
  "moveDay": "Move to another day",
  "markCollected": "Collected",
  "markMissed": "Missed",
  "scheduleTitle": "Collection day for {ref}",
  "collectionDay": "Collection day",
  "chooseDay": "Choose a day",
  "noRoundForBarangay": "No upcoming collection day covers this barangay. Create one under Collection days.",
  "scheduleHint": "The resident is notified.",
  "scheduledToast": "Put on the collection day. The resident was notified.",
  "collectedTitle": "Collected: {ref}",
  "actualQty": "What was actually collected",
  "receiptHint": "The number on the receipt you gave the resident. Each number can be used once.",
  "errReceipt": "Enter the receipt number.",
  "noteToResident": "Note to the resident",
  "collectedToast": "Recorded as collected. The resident has the receipt in the app.",
  "missedTitle": "Missed: {ref}",
  "missedReason": "What happened",
  "missedHint": "For example: nobody was home. The resident sees this.",
  "errMissedNote": "Say what happened.",
  "missedToast": "Recorded as missed. The resident was notified.",
  "newRound": "New collection day",
  "editRound": "Edit collection day",
  "noRoundsTitle": "No collection days yet",
  "noRoundsBody": "Create a collection day so residents can choose it.",
  "round_open": "Open",
  "round_closed": "Closed",
  "round_done": "Done",
  "collectorIs": "Collector: {name}",
  "noCollector": "No collector yet",
  "limitIs": "Up to {count} pickups",
  "noLimit": "No limit",
  "roundCounts": "{scheduled} scheduled · {collected} collected · {missed} missed",
  "collectorSheet": "Collector sheet",
  "viewPickups": "See pickups",
  "barangaysCovered": "Barangays covered",
  "errBarangays": "Choose at least one barangay, or the whole town.",
  "maxPickups": "Maximum pickups",
  "maxHint": "Leave blank for no limit.",
  "errMax": "Enter a number of 1 or more.",
  "collectorStaff": "A staff member",
  "collectorOther": "Someone else",
  "staffMember": "Staff member",
  "notYet": "Not decided yet",
  "collectorName": "Collector's name",
  "collectorNameHint": "For example, a partner junkshop.",
  "sheetCount": "{count} pickups",
  "sheetEmpty": "No pickups on this day yet.",
  "colWhere": "Where",
  "colWho": "Resident",
  "colMaterials": "Expected",
  "colCollected": "Collected",
  "materialsLead": "What the office collects. Residents choose from this list.",
  "addMaterial": "Add a material",
  "editMaterial": "Edit material",
  "noMaterialsTitle": "No materials yet",
  "noMaterialsBody": "Add the recyclables your office collects.",
  "hidden": "Not collected now",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "editName": "Edit {name}",
  "materialName": "Material",
  "materialNameHint": "For example: PET bottles.",
  "unit": "Unit",
  "unitHint": "For example: kg, pcs, sack.",
  "prepNotes": "How to prepare it",
  "prepNotesHint": "For example: rinsed and flattened.",
  "acceptNow": "Collected now (residents can choose it)",
  "exportTitle": "Download pickups",
  "exportLead": "A spreadsheet (CSV) of the office's pickups, with what was collected and the receipt numbers.",
  "downloadCsv": "Download CSV",
  "ev_requested": "Request sent",
  "ev_scheduled": "Put on a collection day",
  "ev_collected": "Collected",
  "ev_missed": "Missed",
  "ev_cancelled": "Cancelled",
  "addressShort": "Address"
}
